/* List of useful utilities */

const updatePageTitle = (pageTitle) => {
  document.title = `Pianeer - ${pageTitle}`
}

export default updatePageTitle



// WEBPACK FOOTER //
// ./src/client/utils/common.js